const nf = new Intl.NumberFormat("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
export const fmt = (n) => nf.format(Number(n) || 0);
export const today = () => new Date().toISOString().slice(0, 10);
export const yearStart = () => `${new Date().getFullYear()}-01-01`;
export const addDays = (iso, d) => {
  const x = new Date(iso);
  x.setDate(x.getDate() + d);
  return x.toISOString().slice(0, 10);
};
export function quarterRange(offset = 0) {
  const n = new Date();
  let q = Math.floor(n.getMonth() / 3) + offset;
  let y = n.getFullYear();
  while (q < 0) { q += 4; y -= 1; }
  const start = new Date(Date.UTC(y, q * 3, 1));
  const end = new Date(Date.UTC(y, q * 3 + 3, 0));
  return { start: start.toISOString().slice(0, 10), end: end.toISOString().slice(0, 10) };
}
export const VAT_RATE = { standard: 0.05, zero: 0, exempt: 0 };
export const r2 = (x) => Math.round((Number(x) || 0) * 100) / 100;
